import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box, Checkbox, Chip, FormControlLabel, FormGroup, Grid, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import {
  ModernDialogActions,
  ModernDialogContent,
  primaryActionSx,
  questionnaireDialogSx,
  questionnairePaperSx,
  QuestionnaireTitle,
  secondaryActionSx,
} from '../QuestionnaireDialogFrame'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// LAP-733 (GE022) — `Nom` is the API/DB identifier (sent in payload); `i18nKey` only drives UI label.
const fintrest = [
  { id: 1, Nom: 'Les cryptomonnaies', i18nKey: 'fiCryptocurrencies' },
  { id: 2, Nom: 'Les matières premières', i18nKey: 'fiCommodities' },
  { id: 3, Nom: 'Les métaux précieux', i18nKey: 'fiPreciousMetals' },
  { id: 4, Nom: 'Société civil', i18nKey: 'fiCivilSociety' },
  { id: 5, Nom: 'Environnement économique', i18nKey: 'fiEconomicEnvironment' },
  { id: 6, Nom: 'Donations et succession', i18nKey: 'fiDonationsInheritance' },
  { id: 7, Nom: 'épargne entreprise', i18nKey: 'fiCorporateSavings' },
  { id: 8, Nom: 'Retraite', i18nKey: 'fiRetirement' },
  { id: 9, Nom: 'Assurance vie', i18nKey: 'fiLifeInsurance' },
  { id: 10, Nom: 'Chevaux de course', i18nKey: 'fiRacehorses' },
  { id: 11, Nom: "Oeuvres d'art et objet de collection", i18nKey: 'fiArtCollectibles' },
  { id: 12, Nom: 'La Famille', i18nKey: 'fiFamily' },
  { id: 13, Nom: 'Fiscalité', i18nKey: 'fiTaxation' },
  { id: 14, Nom: 'Actions', i18nKey: 'fiShares' },
  { id: 15, Nom: 'Immobilier et non-bâti', i18nKey: 'fiRealEstateLand' },
  { id: 16, Nom: 'Placements financier', i18nKey: 'fiFinancialInvestments' },
]
export default function FinanceInterest({ updateReports, setOpenFi }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  let w_finterest = localStorage.getItem('w-finterest')
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [financeInterest, setFinanceInterest] = useState(fintrest)
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [open, setOpen] = useState(true)

  const { handleSubmit, reset } = useForm({})

  useEffect(() => {
    fetchFinanceInterest()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setOpenFi(false)
  }

  const onSubmit = async (data) => {
    const values = []
    selectedCheckboxes.forEach((e) => {
      values.push(fintrest.filter((f) => f.id === e)[0].Nom)
    })
    const payload = {
      selected: values,
    }

    // return

    const response = await makePostRequest(urls.AddFinanceInterest, payload, {}, true)
    if (response.status === 200) {
      if (w_finterest) {
        await makePostRequest(
          '/api/app/user-wizard/',
          { step: w_finterest, completed: true, skip: true },
          {},
          true,
        )

        dispatch(setUserWizardDone({ step: w_finterest, completed: true, skip: true }))
        localStorage.removeItem('w-finterest')
        navigate('/')
      }
      updateReports()
      handleClose()
    }
  }

  const fetchFinanceInterest = async () => {
    const url = urls.getFinanceInterest
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      // setFinanceInterest(data)
    }
  }
  const handelOnChange = (e) => {
    const checkboxValue = parseInt(e.target.name.replace('fi-', ''))
    let updatedSelectedCheckboxes

    if (selectedCheckboxes.includes(checkboxValue)) {
      updatedSelectedCheckboxes = selectedCheckboxes.filter(
        (checkbox) => checkbox !== checkboxValue,
      )
    } else {
      if (selectedCheckboxes.length < 5) {
        updatedSelectedCheckboxes = [...selectedCheckboxes, checkboxValue]
      } else {
        return
      }
    }

    setSelectedCheckboxes(updatedSelectedCheckboxes)
  }
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        className="no-drag"
        PaperProps={{ sx: questionnairePaperSx }}
        sx={questionnaireDialogSx}
      >
        <QuestionnaireTitle
          eyebrow={t('monPatrimoine.financeInterestEyebrow')}
          title={t('monPatrimoine.financeInterestTitle')}
          subtitle={t('monPatrimoine.financeInterestSubtitle')}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModernDialogContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.8 }}>
              <Typography sx={{ color: '#294765', fontSize: 14, fontWeight: 750 }}>
                {t('monPatrimoine.themesSelected')}
              </Typography>
              <Chip
                label={`${selectedCheckboxes.length}/5`}
                sx={{ bgcolor: '#e7f1fb', color: '#1468b7', borderRadius: 2, fontWeight: 850 }}
              />
            </Stack>
            <FormGroup>
              <Grid container spacing={1.2}>
                {financeInterest.map((ele) => (
                  <Grid item xs={12} sm={6} md={4} key={ele.id}>
                    <Box
                      sx={{
                        height: '100%',
                        borderRadius: 2,
                        bgcolor: selectedCheckboxes.includes(ele.id) ? '#e7f1fb' : '#ffffff',
                        border: selectedCheckboxes.includes(ele.id)
                          ? '1px solid rgba(20, 104, 183, 0.45)'
                          : '1px solid rgba(20, 104, 183, 0.12)',
                        boxShadow: '0 10px 24px rgba(16, 35, 63, 0.045)',
                        transition: 'border-color 120ms ease, background-color 120ms ease',
                      }}
                    >
                      <FormControlLabel
                        className="ficheck"
                        control={<Checkbox checked={selectedCheckboxes.includes(ele.id)} />}
                        onChange={handelOnChange}
                        disabled={
                          selectedCheckboxes.length < 5
                            ? false
                            : selectedCheckboxes.includes(ele.id)
                            ? false
                            : true
                        }
                        label={ele.i18nKey ? t('monPatrimoine.' + ele.i18nKey) : ele.Nom}
                        name={'fi-' + ele.id}
                        sx={{
                          width: '100%',
                          minHeight: 58,
                          m: 0,
                          px: 1.3,
                          py: 0.6,
                          color: '#152b47',
                          '& .MuiFormControlLabel-label': {
                            fontSize: 14,
                            fontWeight: 750,
                            lineHeight: 1.2,
                          },
                          '& .MuiCheckbox-root': {
                            color: '#7d99b5',
                            '&.Mui-checked': { color: '#1468b7' },
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </ModernDialogContent>
          <ModernDialogActions>
            <Button variant="contained" type="submit" sx={primaryActionSx}>
              {t('monPatrimoine.validate')}
            </Button>
            <Button
              sx={secondaryActionSx}
              onClick={() => {
                handleClose()
                if (w_finterest) {
                  localStorage.removeItem('w-finterest')
                  navigate('/')
                }
              }}
            >
              {t('monPatrimoine.cancel')}
            </Button>
          </ModernDialogActions>
        </form>
      </Dialog>
    </>
  )
}
